import { chartDataQuery } from "@/api/queries";
import { abbreviateNumber } from "@/utils";
import { useMediaQuery } from "@react-hookz/web";
import { useAtomValue } from "jotai";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export function Chart() {
  const isMobileDevice = useMediaQuery("(max-device-width: 480px)");

  const { data, keys } = useAtomValue(chartDataQuery);

  if (!data || keys[0] === undefined) return null;

  return (
    <div
      style={{
        width: "100%",
        height: 260,
        marginLeft: isMobileDevice ? "-30px" : "",
      }}
    >
      <ResponsiveContainer>
        <LineChart
          width={isMobileDevice ? 280 : 375}
          height={isMobileDevice ? 360 : 260}
          data={data}
          layout={isMobileDevice ? "vertical" : "horizontal"}
          margin={{
            top: 5,
            right: -30,
            left: 10,
            bottom: 5,
          }}
        >
          <CartesianGrid
            strokeDasharray="5"
            vertical={isMobileDevice}
            horizontal={!isMobileDevice}
          />
          {!isMobileDevice ? (
            <XAxis dataKey="name" angle={45} minTickGap={1} tickCount={12} />
          ) : (
            <XAxis type="number" tickFormatter={abbreviateNumber} width={25} />
          )}
          {!isMobileDevice ? (
            <YAxis tickFormatter={abbreviateNumber} width={25} />
          ) : (
            <YAxis type="category" dataKey="name" minTickGap={1} tickCount={12} />
          )}
          <Tooltip />
          <Line
            type="monotone"
            activeDot={{ r: 12 }}
            dataKey={keys[0]}
            strokeOpacity={1}
            isAnimationActive={false}
            stroke="#3cf1c6"
          />
          <Line
            type="monotone"
            dataKey={keys[1]}
            strokeOpacity={1}
            isAnimationActive={false}
            stroke="#ff0080"
            activeDot={{ r: 12 }}
          />
          <Line
            type="monotone"
            activeDot={{ r: 12 }}
            dataKey={"National Average"}
            strokeOpacity={1}
            isAnimationActive={false}
            stroke="#f2f2f2"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
